import {
  ICohortRefFieldsFragment,
  ISliceNameHint,
} from '../apollo/graphqlSchema';

export default (
  originalHint?: ISliceNameHint[],
  cohortRefs?: ICohortRefFieldsFragment[],
) => {
  if (!cohortRefs?.length || !originalHint?.length) {
    return false;
  }

  const activeCohortRef = cohortRefs.find((cohortRef) => {
    const hint = originalHint.find(
      (hint) => hint.value === cohortRef.cohort.name,
    );

    if (hint) {
      return cohortRef;
    }

    return undefined;
  });

  return !!(
    activeCohortRef && activeCohortRef.cohort.__typename === 'CompoundCohort'
  );
};
